import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-assistant-choose-patient-modal',
  templateUrl: './assistant-choose-patient-modal.component.html',
  styleUrls: ['./assistant-choose-patient-modal.component.scss'],
  standalone: false
})
export class AssistantChoosePatientModalComponent implements OnInit {
  patients: any[] = []; // assegna dal data
  selectedPatient: string | null = null;
  selectedDrug: string | null = null;
  // Nuove flags per semplificare la logica nel template
  hasMatchingPatients: boolean = false;
  matchingPatientsIsNull: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<AssistantChoosePatientModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    const matching = this.data?.assistantResponse?.content?.matchingPatients;
    this.matchingPatientsIsNull = matching == null;
    this.patients = Array.isArray(matching) ? matching : [];
    this.hasMatchingPatients = this.patients.length > 0;
    const drugs = this.data?.assistantResponse?.content?.drugs || [];
    //console.log('patients', this.patients);
    // selezione automatica se singolo elemento
    if (this.patients.length === 1) {
      this.selectedPatient = this.patients[0];
    }
    if (drugs.length === 1) {
      this.selectedDrug = drugs[0];
    }
  }

  onSelectionChange(ev?: CustomEvent) {
    if (ev?.detail && ev.detail.value !== undefined) {
      this.selectedPatient = ev.detail.value;
    }
  }

  get isConfirmEnabled(): boolean {
    const content = this.data?.assistantResponse?.content;
    const matchingPatients = Array.isArray(content?.matchingPatients) ? content!.matchingPatients : [];
    const drugs = content?.drugs;


    const hasPatients = matchingPatients.length > 0;
    const hasDrugs = Array.isArray(drugs) && drugs.length > 0;

    // Consider 'drugs' missing or empty as 'no drugs' available
    const drugsMissingOrEmpty = drugs === undefined || drugs === null || (Array.isArray(drugs) && drugs.length === 0);
    const drugsExistsAndEmpty = Array.isArray(drugs) && drugs.length === 0;

    // Caso 1: entrambi presenti e con elementi → entrambi obbligatori
    if (hasPatients && hasDrugs) {
      return !!(this.selectedPatient && this.selectedDrug);
    }

    // Caso 2: ci sono pazienti e drugs è vuoto/assente → basta selezionare il paziente
    if (hasPatients && drugsMissingOrEmpty) {
      return !!this.selectedPatient;
    }

    // Caso 3: solo drugs presenti e con elementi → basta il drug
    if (!hasPatients && hasDrugs) {
      return !!this.selectedDrug;
    }

    // Caso 4: la proprietà 'drugs' esiste ma è vuota e non ci sono pazienti
    // non ci sono elementi selezionabili → disabilita conferma
    if (drugsExistsAndEmpty && !hasPatients) {
      return false;
    }

    // Fallback: consenti se è selezionato qualcosa
    return !!(this.selectedPatient || this.selectedDrug);

  }


  async onConfirm(): Promise<void> {
    //console.log('Paziente selezionato:', this.selectedPatient);
    console.log('Farmaco selezionato:', this.selectedDrug);

    const hasPatient = !!this.selectedPatient;
    const hasDrug = !!this.selectedDrug;

    if (hasPatient || hasDrug) {
      const result = {
        datapatient: hasPatient ? this.selectedPatient : null,
        productCode: hasDrug ? this.selectedDrug : null
      };

      //console.log('Selezione confermata:', result);
      this.dialogRef.close(result);
    } else {
      console.warn('Nessuna selezione effettuata');
      this.dialogRef.close(null);
    }

  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

}
